"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineApiPostCall = void 0;
function defineApiPostCall(api, routeName, definition) {
    const procedure = (values) => {
        return api
            .makePostCall(definition.route, values)
            .then(result => {
            if (definition.process) {
                definition.process(result);
            }
            return result;
        }, error => {
            api.onError(error);
            return null;
        });
    };
    const dynamic = api;
    if (!dynamic.post) {
        dynamic.post = {};
    }
    dynamic.post[routeName] = procedure;
    return api;
}
exports.defineApiPostCall = defineApiPostCall;
